import {
  Activity,
  BellRing,
  Bot,
  Box,
  Building2,
  CircuitBoard,
  ClipboardList,
  Cpu,
  Database,
  Factory,
  FileCode2,
  Gauge,
  LayoutDashboard,
  MapPin,
  OctagonAlert,
  Package,
  ScrollText,
  Tag,
  TrendingUp,
  TriangleAlert,
  UserCog,
  Users,
  Webhook,
  Workflow,
  Zap,
  type LucideIcon
} from 'lucide-react'
import { GRAPH_NODE_TYPE_REGISTRY, type NodeLabel } from '@atbash-labs/ontology-core'

/**
 * Lucide components for every icon name the generated node-type registry
 * emits (per-domain defaults + per-label overrides in the nodespec).
 * Mirrors the per-value maps (`equipment-icon.ts`, `compute-icon.ts`) but
 * keyed off the registry's per-label metadata instead of node properties.
 */
const REGISTRY_ICONS: Readonly<Record<string, LucideIcon>> = {
  Activity,
  BellRing,
  Bot,
  Box,
  Building2,
  CircuitBoard,
  ClipboardList,
  Cpu,
  Database,
  Factory,
  FileCode2,
  Gauge,
  LayoutDashboard,
  MapPin,
  OctagonAlert,
  Package,
  ScrollText,
  Tag,
  TrendingUp,
  TriangleAlert,
  UserCog,
  Users,
  Webhook,
  Workflow,
  Zap
}

export function registryIconFor(label: NodeLabel | null): LucideIcon {
  if (!label) return Box
  return REGISTRY_ICONS[GRAPH_NODE_TYPE_REGISTRY[label].icon] ?? Box
}
